module.exports = __webpack_public_path__ + "static/media/line-news.5b59985f.png";